import axios from 'axios'

export const client = axios.create({
    baseURL: window.CONFIG.baseURL,
    responseType: 'json'
});